var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn btn-link",on:{"click":_vm.toggleToWishlist}},[_c('i',{staticClass:"fa-regular fa-heart",class:{'fa-solid': this.wishlist.find((product) => product.id == this.dataProduct.id)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }